export default "__VITE_ASSET__CXVodFXI__"